import { useState } from 'react';
import { apiService } from '../services/api';
import { ChartType } from '../types/visualization';

export const useNaturalLanguageWidget = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  const createWidgetFromNaturalLanguage = async (
    nlQuery: string,
    onSuccess: (widgetData: {
      name: string;
      nl_query: string;
      sql_query: string;
      visualization_type: ChartType;
      config?: any;
      metadata?: any;
    }) => void
  ) => {
    if (!nlQuery.trim()) {
      throw new Error('Query cannot be empty');
    }

    setIsGenerating(true);
    try {
      const result = await apiService.translateNaturalLanguageToSQL(nlQuery);

      const widgetData = {
        name: result.config?.title || result.visualization?.title || 'AI Generated Widget',
        nl_query: result.nl_query || nlQuery,
        sql_query: result.sql_query || result.sql || '',
        visualization_type: result.chartType || result.visualization?.chartType || 'table',
        config: result.config || {},
        metadata: result.metadata || {}
      };

      await onSuccess(widgetData);
      return result;
    } catch (error) {
      console.error('Error creating widget:', error);
      throw new Error('Failed to create widget. Please try a different query.');
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    createWidgetFromNaturalLanguage,
    isGenerating,
  };
};
